let productTree = require('./ProductTree.js');
let colors = require('../Colors.js');

let colorPicker = colors(['A1', 'A2']);
colorPicker.id = 'color';

let indications = require('../HKP.js');

let indicationNames = Object.keys(indications).map(key => {
  return {value: key, label: {de: key + ' - ' + indications[key].de, en: key + ' - ' + indications[key].en}};
});


function getTreeForIndication(indicationName) {
  let tree = JSON.parse(JSON.stringify(productTree));
  //console.log("tree", indicationName);
  for (let mat in tree.children) {
    for (let name in tree.children[mat].children) {
      if (!tree.children[mat].children[name].hasOwnProperty('indications') || !tree.children[mat].children[name].indications.includes(indicationName)) {
        if (tree.children[mat].children[name].hasOwnProperty('children')) {
          for (let childName in tree.children[mat].children[name].children) {
            if (!tree.children[mat].children[name].children[childName].hasOwnProperty('indications') || !tree.children[mat].children[name].children[childName].indications.includes(indicationName)) {
              //console.log("del child", mat, name, childName);
              delete tree.children[mat].children[name].children[childName];
            }
          }
          if (Object.keys(tree.children[mat].children[name].children).length <= 0)
            delete tree.children[mat].children[name];
        } else {
          //console.log("del child2", mat, name);
          delete tree.children[mat].children[name];
        }
      }
    }
    if (Object.keys(tree.children[mat].children).length <= 0)
      delete tree.children[mat];
  }
  return tree;
}

function getIndicationFinders() {
  let finders = [];
  for (let indicationNameObj of indicationNames) {
    let finder = {
      id: 'material',
      label: {
        de: 'Material',
        en: 'Material',
      },
      type: 'finder',
      required: true,
      requires: {
        indication: indicationNameObj.value
      },
      calculatePrices: true,
      productTree: getTreeForIndication(indicationNameObj.value),
    };
    finders.push(finder);
  }
  return finders;
}

function getColors() {
  let mapItemnumColor = {};
  let tree = JSON.parse(JSON.stringify(productTree));
  let itemnum = '';
  for (let mat in tree.children) {
    for (let name in tree.children[mat].children) {
      if (tree.children[mat].children[name].hasOwnProperty('itemnum')) {
        itemnum = tree.children[mat].children[name].itemnum;
        if (tree.children[mat].children[name].hasOwnProperty('properties') && tree.children[mat].children[name].properties.hasOwnProperty('color'))
          mapItemnumColor[itemnum] = tree.children[mat].children[name].properties.color;
      }
      else if (tree.children[mat].children[name].hasOwnProperty('children')) {
        for (let childName in tree.children[mat].children[name].children) {
          if (tree.children[mat].children[name].children[childName].hasOwnProperty('itemnum')) {
            itemnum = tree.children[mat].children[name].children[childName].itemnum;
            if (tree.children[mat].children[name].children[childName].hasOwnProperty('properties') && tree.children[mat].children[name].children[childName].properties.hasOwnProperty('color'))
              mapItemnumColor[itemnum] = tree.children[mat].children[name].children[childName].properties.color;
            break;
          }
        }
      }
    }
  }
  let arr = [];
  for (let itemnum in mapItemnumColor) {
    arr.push({
      ...mapItemnumColor[itemnum],
      id: 'color',
      requires: {
        'material.selectedProduct.itemnum': itemnum
      }
    });
  }
  //console.log("arr colors", arr);
  return arr;
}




module.exports = {
  type: 'selector',
  id: 'therapy',
  title: 'Therapie',
  icon: 'sliders-h',
  teethView: 'top',
  layers: [
    {
      id: 'stumps',
      label: {de: 'Stümpfe', en: 'Stumps'},
      //required: true,
      range: 32,
      maxunits: 32,
      defaultToothItems: {
        '2.5.4': 1
      },
      applyTo: 'both',
      text: 'x',
      color: 'transparent',
      textColor: 'orange',
      showIf: {
        //$not: {allTeethCanBeMoved: '1'},
      },
    },
    {
      id: 'model',
      label: {de: 'Modell', en: 'model'},
      range: 32,
      maxunits: 32,
      defaultToothItems: {
        '2.5.2': 1
      },
      applyTo: 'both',
      text: 'M',
      color: 'teal',
      textColor: 'white',
      popup: [
        {
          label: {
            de: 'Modell & Stümpfe',
            en: 'Model & Stubs',
          },
          form: [
            {
              id: 'gingivamask',
              type: 'number',
              min: 0,
              max: 99,
              label: {de: 'Zahnfleischmaske', en: 'Gingiva Mask'},
              itemnum: '2.5.3',
              required: false,
              value: 0
            },
            {
              id: 'extra',
              type: 'select',
              label: {de: 'Herausnehmbar/Extra', en: 'Loose/Extra'},
              required: true,
              options: [{value: 'sawed', label: {de: 'Gesägtes Modell', en: 'Sawed Model'}}, {value: 'unsawed', label: {de: 'Ungesägtes Modell', en: 'Non-Sawed Model'}}]
            },
          ]
        }
      ],
      showIf: {
        //$not: {allTeethCanBeMoved: '1'},
      },
    },
    {
      label: {
        de: 'Verblockung',
        en: 'Connector',
      },
      id: 'connector',
      range: 16,
      maxunits: 32,
      withinJaw: true,
      applyTo: 'both'
    },
    {
      label: {
        de: 'Produkt',
        en: 'Product',
      },
      formLabel: {
        de: 'Produktdetails',
        en: 'Product details',
      },
      id: 'finder',
      range: 16,
      maxunits: 32,
      withinJaw: true,
      applyTo: 'both',
      text: {
        field: 'indication',
        options: indicationNames.map(x => x.value)
      },
      color: '#6b75c0',
      textColor: 'white',
      popup: [
        {
          label: {
            de: 'Produktauswahl',
            en: 'Product selection',
          },
          form: [
            {
              id: 'indication',
              type: 'select',
              label: {de: 'Indikation', en: 'Indication'},
              required: true,
              options: indicationNames
            },
            {
              id: 'implantsystem',
              type: 'text',
              label: {de: 'Implantatsystem', en: 'Implant system'},
              required: false,
            },
            {
              id: 'diameter',
              type: 'text',
              label: {de: 'Durchmesser (in mm)', en: 'Diameter (in mm)'},
              required: false,
            },
            {
              id: 'refnum',
              type: 'text',
              label: {de: 'Ref.nr.', en: 'Ref no.'},
              required: false,
            }
          ]
        }, {
          id: 'matcolor',
          label: {
            de: 'Material & Farbe',
            en: 'Material & Color',
          },
          form: [
            ...getIndicationFinders(),
            ...getColors(),
          ]
        },
        {
          label: {
            de: 'Eigenschaften',
            en: 'Properties',
          },
          form: [
            {
              id: 'contactpoints',
              type: 'select',
              label: { de: 'Kontaktpunkte', en: 'Contact points'},
              options: [
                {value: 'locker', label: {de: 'locker', en: 'easy'}},
                {value: 'stramm', label: {de: 'stramm', en: 'tight'}},
              ]
            },
            {
              id: 'occlusalcontacts',
              type: 'select',
              label: { de: 'Okklusalkontakte', en: 'Occlusal contacts'},
              options: [
                {value: 'locker', label: {de: 'locker', en: 'easy'}},
                {value: 'stramm', label: {de: 'stramm', en: 'tight'}},
              ]
            },
            {
              id: 'friction',
              type: 'select',
              label: { de: 'Friktion', en: 'Friction'},
              options: [
                {value: 'locker', label: {de: 'locker', en: 'easy'}},
                {value: 'stramm', label: {de: 'stramm', en: 'tight'}},
              ]
            },
            {
              id: 'bridge_design',
              type: 'tiles',
              inline: true,
              label: {
                de: 'Brückengliedgestaltung',
                en: 'Bridge Design'
              },
              height: '116px',
              options: [
                {
                  value: '1',
                  label: {
                    de: '1',
                    en: '1'
                  },
                  imageUrl: '/img/bridge_design/bridge_design1.png'
                },
                {
                  value: '2',
                  label: '2',
                  imageUrl: '/img/bridge_design/bridge_design2.png'
                },
                {
                  value: '3',
                  label: '3',
                  imageUrl: '/img/bridge_design/bridge_design3.png'
                },
              ]
            }
          ]
        }
      ]
    }
  ]
}


/*

About layers:
* `maxunits`: The maximum number of units that can be placed in one jaw
* `range`: The maximum number of teeth that be selected
* `applyTo`: To what jaws should the layer apply?
  - `both`: Both jaws
  - `upper`: Only lower jaw
  - `upper`: Only upper jaw

If one of the jaws has no layers, it will not be displayed

*/
